// src/pages/premium/UpscAnalysis.jsx
import React from "react";

export default function UpscAnalysis() {
  return (
    <div className="container mt-5 text-center">
      <h2>📊 Detailed UPSC Analysis</h2>
      <p>This is your premium analysis content.</p>
    </div>
  );
}